module.exports = __webpack_public_path__ + "static/media/nsec_logo.46760267.png";